<template>
    <div class="row">
        <div>
            <div class="tracking-form">
                <p>Номер отправления</p>
                <q-input square
                         outlined
                         v-model="form.number"
                         label="Введите номер отправления"
                         :error-message="form.errors.get('number')"
                         :error="form.errors.has('number')">
                    <template v-slot:after>
                        <q-btn color="primary" label="Отследить" @click="tracking" />
                    </template>
                </q-input>
            </div>
            <p v-if="!history">Если вам не пришло СМС-сообщение с кодом отправления, пожалуйста сообщите нам по телефону <b>8-800-700-27-68 </b>(беспл. по России)</p>
            <div v-else>
                <p><strong>Накладная № {{ history.tracking_number }} от {{ history.order_date }}</strong></p>
                <ul>
                    <li>Откуда: {{ history.sender_city }}</li>
                    <li>Отправитель: {{ history.sender_name }}</li>
                    <li>Куда: {{ history.recipient_city }}</li>
                </ul>
                <q-list>
                    <q-item v-for="status in history.statuses" :key="status.date">
                        <q-item-section>{{ status.city }}</q-item-section>
                        <q-item-section>{{ status.date }}</q-item-section>
                        <q-item-section>{{ status.description }}</q-item-section>
                    </q-item>
                </q-list>
            </div>
        </div>
        <div></div>
    </div>
</template>

<script>
    import { Form } from '../../classes/Form';

    export default {
        name: "Tracking",
        data () {
            return {
                form: new Form({
                    number: '',
                }),
                history: false
            }
        },
        methods: {
            submit () {
                let _this = this;

                _this.form.post('/tracking')
                    .then(response => {
                        if (response.status === 'success') {
                            _this.form.reset();
                            _this.history = response.data;
                        }
                    });
            },
            tracking () {
                let _this = this;
                _this.submit();
            }
        }
    }
</script>
